<template>
  <vb-checkbox
    @change="handle_change"
    :vb_options="{
      text: 'Bagagli inclusi',
      value:
        included_checked_bags_only === '1' || included_checked_bags_only === 1,
      type: 'light',
      switch: true,
    }"
  />
</template>

<script>
export default {
  name: "search-by-bags",
  created() {
    document.body.classList.remove("overflow-hidden");
  },
  computed: {
    included_checked_bags_only: {
      get() {
        return this.$store.state.liveflight.included_checked_bags_only !==
          undefined
          ? this.$store.state.liveflight.included_checked_bags_only
          : 0;
      },
      set(value) {
        this.$store.commit("liveflight/included_checked_bags_only", value);
      },
    },
  },
  methods: {
    handle_change(selected) {
      this.included_checked_bags_only = selected ? "1" : "0";
      window.eventBus.$emit("change-search-by", {
        included_checked_bags_only: this.included_checked_bags_only,
      });
      this.scroll_top();
    },
  },
};
</script>
